module.exports = __webpack_public_path__ + "static/goz&me-0d76f93f7782179ad8965743c83e5999.png";